const Locations = [
  'Centennial 2, Bengaluru', 'Centennial 3, Bengaluru', 'Ecospace 3B, Bengaluru', 'Ecoworld, Bengaluru',
  'Ecoworld 4D, Bengaluru', 'New Indiranagar, Bengaluru', 'Residency Road, Bengaluru', 'Whitefield, Bengaluru', 'Yelahanka, Bengaluru',
  'BKC, Equinox T3, Mumbai', 'BKC, Equinox T3, 7th Floor, Mumbai', 'Powai, Spectra, Mumbai', 'Powai, Prudential, Mumbai', 'Powai, Winchester, Mumbai', 'Worli, Mumbai',
  'Aerocity, Delhi NCR', 'Cybercity, Delhi NCR', 'Golf Course Road, Delhi NCR', 'Gurugram, Sector 21, Delhi NCR', 'Noida, Sector 135, Delhi NCR',
  'Noida, Sector 62, Delhi NCR', 'Gurugram, Sector 48, Delhi NCR', 'OMR, Chennai', 'OMR 3B 5F, Chennai', 'Perungudi, Chennai',
  'Skyview, Hyderabad', 'Sandhya Techno, Skyview, Hyderabad', 'Baner, Pune', 'AtelierSuites', 'APIS IT Incubation Centre, Vizag'
];

const jobs = [
  {
    id: 'JR-080001',
    title: 'Frontend Developer - React.js',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Develop responsive web interfaces using React.js stack.',
    skills: ['HTML', 'CSS', 'JavaScript', 'JSX', 'React Router', 'Redux', 'Zustand', 'Context API', 'Tailwind', 'Webpack', 'Babel'],
    responsibilities: ['Build dynamic UI with React', 'State management using Redux/Zustand', 'Implement Tailwind styles']
  },
  {
    id: 'JR-080002',
    title: 'Frontend Developer - Angular',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Develop dynamic SPAs using Angular framework.',
    skills: ['HTML', 'SCSS', 'CSS', 'RxJS', 'Angular CLI', 'NgRx'],
    responsibilities: ['Develop components in Angular', 'Use NgRx for state management', 'Maintain SCSS styles']
  },
  {
    id: 'JR-080003',
    title: 'Frontend Developer - Vue.js',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Develop SPAs with Vue.js and related libraries.',
    skills: ['JavaScript', 'TypeScript', 'HTML', 'CSS', 'SCSS', 'Tailwind CSS', 'Vuex', 'Pinia', 'Vue Router', 'Vite', 'Webpack'],
    responsibilities: ['Develop features with Vue', 'State management with Vuex/Pinia', 'Use Vite/Webpack for builds']
  },
  {
    id: 'JR-080004',
    title: 'Frontend Developer - Svelte',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-07-28',
    description: 'Create performant web apps using Svelte.',
    skills: ['HTML', 'CSS', 'JavaScript', 'Svelte syntax', 'Vite', 'Rollup'],
    responsibilities: ['Build UIs using Svelte', 'Optimize with Rollup', 'Implement lightweight frontend logic']
  },
  {
    id: 'JR-080005',
    title: 'Frontend Developer - Vanilla JS',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-07-28',
    description: 'Develop web interfaces using HTML, CSS and JS without frameworks.',
    skills: ['HTML', 'CSS', 'JavaScript'],
    responsibilities: ['Write clean vanilla JS', 'Style pages with CSS', 'Create accessible UI']
  },

  {
    id: 'JR-080006',
    title: 'Backend Developer - Django',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-5 years',
    postedDate: '2025-07-28',
    description: 'Build secure APIs and server-side logic using Django framework.',
    skills: ['Python', 'Django', 'Django ORM', 'HTML', 'CSS', 'Django REST Framework', 'PostgreSQL', 'MySQL', 'Jinja2'],
    responsibilities: ['Develop RESTful APIs', 'Integrate databases', 'Use Django ORM']
  },
  {
    id: 'JR-080007',
    title: 'Backend Developer - Spring Boot',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-6 years',
    postedDate: '2025-07-28',
    description: 'Develop enterprise-grade Java applications using Spring Boot.',
    skills: ['Java', 'Spring Boot', 'Thymeleaf', 'JPA', 'Hibernate', 'MySQL', 'PostgreSQL', 'Spring Security', 'JWT'],
    responsibilities: ['Build secure APIs', 'Database integration', 'Security configuration']
  },
  {
    id: 'JR-080008',
    title: 'Backend Developer - Laravel',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Develop backend services with Laravel and PHP.',
    skills: ['PHP', 'Laravel', 'Blade', 'MySQL', 'PostgreSQL', 'Composer', 'Eloquent ORM', 'REST API', 'Sanctum'],
    responsibilities: ['Create Laravel apps', 'Use Blade templating', 'Secure APIs using Sanctum']
  },
  {
    id: 'JR-080009',
    title: 'Backend Developer - Node.js',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Develop Node.js services and APIs using Express framework.',
    skills: ['JavaScript', 'TypeScript', 'Express.js', 'MongoDB', 'Mongoose', 'REST API', 'GraphQL', 'JWT', 'OAuth', 'Nodemailer', 'Cluster', 'Socket.IO'],
    responsibilities: ['Build scalable APIs', 'Secure routes with JWT/OAuth', 'Integrate mailing and WebSockets']
  },
  {
    id: 'JR-080010',
    title: 'Backend Developer - Ruby on Rails',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Develop backend applications using Ruby on Rails.',
    skills: ['Ruby', 'ERB', 'ActiveRecord', 'PostgreSQL', 'MySQL', 'Rails API mode'],
    responsibilities: ['Build REST APIs', 'Database modeling', 'Use ActiveRecord']
  },

  {
    id: 'JR-080011',
    title: 'DevOps Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Implement CI/CD pipelines and manage cloud infrastructure.',
    skills: ['Docker', 'Kubernetes', 'CI/CD', 'GitLab CI', 'Terraform', 'AWS', 'Jenkins'],
    responsibilities: ['Manage deployments', 'Automate infrastructure']
  },
  {
    id: 'JR-080147',
    title: 'Data Scientist',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Analyze data, build predictive models and deliver insights.',
    skills: ['Python', 'NumPy', 'Pandas', 'Scikit-learn', 'Matplotlib', 'Jupyter', 'EDA'],
    responsibilities: ['Build ML models', 'Interpret and visualize data']
  },
  {
    id: 'JR-080012',
    title: 'AI/ML Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Design and implement machine learning solutions.',
    skills: ['Python', 'TensorFlow', 'Keras', 'OpenCV', 'PyTorch', 'MLflow', 'Flask'],
    responsibilities: ['Train AI models', 'Deploy models into production']
  },
  {
    id: 'JR-080013',
    title: 'Cloud Engineer - AWS',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Build and manage scalable cloud infrastructure.',
    skills: ['AWS EC2', 'S3', 'Lambda', 'RDS', 'CloudFormation', 'IAM', 'CloudWatch'],
    responsibilities: ['Deploy services on AWS', 'Monitor cloud performance']
  },
  {
    id: 'JR-080014',
    title: 'QA Automation Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Write and execute automated test scripts.',
    skills: ['Selenium', 'Cypress', 'Playwright', 'Mocha', 'Chai', 'Postman', 'Jest'],
    responsibilities: ['Create automated test cases', 'Improve testing processes']
  },
  {
    id: 'JR-080015',
    title: 'Test Engineer - Selenium',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Design and run Selenium-based test suites.',
    skills: ['Selenium', 'Java', 'TestNG', 'JUnit', 'XPath', 'Maven'],
    responsibilities: ['Automate browser tests', 'Maintain test framework']
  },
  {
    id: 'JR-080016',
    title: 'Embedded Software Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Develop software for embedded systems and devices.',
    skills: ['C', 'C++', 'RTOS', 'UART', 'I2C', 'SPI', 'Microcontrollers'],
    responsibilities: ['Write firmware code', 'Interface with hardware components']
  },
  {
    id: 'JR-080017',
    title: 'Cybersecurity Analyst',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Ensure security of infrastructure and data.',
    skills: ['Firewalls', 'IDS/IPS', 'SIEM', 'Vulnerability Assessment', 'Penetration Testing', 'Nmap'],
    responsibilities: ['Perform risk analysis', 'Monitor and mitigate threats']
  },
  {
    id: 'JR-080018',
    title: 'Mobile App Developer - Android',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Build native Android apps using Kotlin and Java.',
    skills: ['Kotlin', 'Java', 'Android Studio', 'Jetpack Compose', 'Room DB'],
    responsibilities: ['Develop Android features', 'Ensure UI responsiveness']
  },
  {
    id: 'JR-080019',
    title: 'Mobile App Developer - iOS',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Build native iOS apps using Swift and SwiftUI.',
    skills: ['Swift', 'SwiftUI', 'Xcode', 'Combine', 'CoreData'],
    responsibilities: ['Develop iOS features', 'Follow App Store guidelines']
  },
  {
    id: 'JR-080020',
    title: 'Software Architect',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '5-8 years',
    postedDate: '2025-07-28',
    description: 'Design architecture for scalable software systems.',
    skills: ['Microservices', 'Design Patterns', 'REST', 'GraphQL', 'System Design'],
    responsibilities: ['Lead architecture planning', 'Ensure best practices across teams']
  },
    {
    id: 'JR-080148',
    title: 'Spring Boot Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Build RESTful APIs and backend services using Spring Boot and Java.',
    skills: ['Java', 'Spring Boot', 'Spring MVC', 'Hibernate', 'JPA', 'Maven', 'REST API', 'MySQL'],
    responsibilities: ['Develop backend microservices', 'Integrate databases and external services', 'Ensure code quality and performance']
  },
  {
    id: 'JR-080021',
    title: 'Golang Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Design and implement scalable backend systems using Go.',
    skills: ['Go', 'Goroutines', 'Channels', 'REST APIs', 'gRPC', 'Docker', 'PostgreSQL'],
    responsibilities: ['Write scalable backend services', 'Use Go concurrency effectively', 'Work with cloud-native tools']
  },
  {
    id: 'JR-080022',
    title: 'Rust Systems Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Build high-performance, memory-safe applications using Rust.',
    skills: ['Rust', 'Cargo', 'Tokio', 'Actix Web', 'Memory management', 'Systems programming'],
    responsibilities: ['Develop system-level features', 'Write safe and fast code', 'Handle low-level APIs']
  },
  {
    id: 'JR-080023',
    title: 'Salesforce Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Develop and customize Salesforce applications and workflows.',
    skills: ['Salesforce', 'Apex', 'Visualforce', 'Lightning Components', 'SOQL', 'REST API'],
    responsibilities: ['Create custom Salesforce apps', 'Integrate APIs and automate processes', 'Maintain CRM functionality']
  },
  {
    id: 'JR-080024',
    title: 'SAP ABAP Consultant',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-6 years',
    postedDate: '2025-07-28',
    description: 'Develop and enhance SAP modules using ABAP programming.',
    skills: ['SAP ABAP', 'RFC', 'IDOC', 'BAPI', 'SmartForms', 'ALV Reports'],
    responsibilities: ['Write and optimize ABAP code', 'Support SAP implementations', 'Work with functional consultants']
  },
  {
    id: 'JR-080025',
    title: 'ServiceNow Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Develop ITSM and workflow automation on ServiceNow platform.',
    skills: ['ServiceNow', 'JavaScript', 'Glide API', 'Workflows', 'CMDB', 'ITIL'],
    responsibilities: ['Customize ServiceNow modules', 'Implement workflows and scripts', 'Integrate with third-party tools']
  },
  {
    id: 'JR-080026',
    title: 'Power BI Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Develop business intelligence dashboards and data models using Power BI.',
    skills: ['Power BI', 'DAX', 'Power Query', 'Data Modeling', 'SQL', 'Excel'],
    responsibilities: ['Create interactive dashboards', 'Build data pipelines and models', 'Support decision-making with reports']
  },
  {
    id: 'JR-080027',
    title: 'Data Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Design and build robust data pipelines and ETL workflows.',
    skills: ['Python', 'SQL', 'Airflow', 'ETL', 'Spark', 'BigQuery', 'Data Lakes'],
    responsibilities: ['Ingest and process data from various sources', 'Ensure data quality and availability', 'Support analytics and ML teams']
  },
  {
    id: 'JR-080028',
    title: 'BI Analyst',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Analyze business data and build visualizations to support insights.',
    skills: ['Tableau', 'Power BI', 'SQL', 'Excel', 'Google Data Studio', 'Data Analysis'],
    responsibilities: ['Gather and analyze business data', 'Create dashboards and KPIs', 'Present actionable insights']
  },
  {
    id: 'JR-080029',
    title: 'ETL Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Develop ETL processes for large-scale data integration.',
    skills: ['Informatica', 'Talend', 'SSIS', 'SQL', 'Shell Scripts', 'Data Warehousing'],
    responsibilities: ['Design ETL mappings and jobs', 'Optimize for performance and reliability', 'Maintain documentation and logs']
  },
  {
    id: 'JR-080030',
    title: 'System Integrator',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-6 years',
    postedDate: '2025-07-28',
    description: 'Integrate disparate systems and ensure seamless data flow across platforms.',
    skills: ['API Integration', 'Middleware', 'REST', 'SOAP', 'JSON', 'XML', 'Python', 'Shell Scripting'],
    responsibilities: ['Integrate 3rd-party platforms', 'Ensure smooth data exchange', 'Monitor and troubleshoot integration flows']
  },
    {
    id: 'JR-080031',
    title: 'Office Manager',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Oversee daily office operations and ensure workplace efficiency.',
    skills: ['Office Administration', 'Vendor Management', 'Inventory Control', 'Communication'],
    responsibilities: ['Manage office supplies and services', 'Oversee admin staff', 'Ensure workplace compliance']
  },
  {
    id: 'JR-080032',
    title: 'Procurement Specialist',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Manage purchasing activities and supplier relations.',
    skills: ['Vendor Management', 'Negotiation', 'Purchase Orders', 'ERP Tools'],
    responsibilities: ['Handle procurement processes', 'Negotiate contracts', 'Track inventory needs']
  },
  {
    id: 'JR-080033',
    title: 'Logistics Coordinator',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Coordinate transportation, warehousing, and delivery operations.',
    skills: ['Supply Chain', 'Logistics Software', 'Coordination', 'Documentation'],
    responsibilities: ['Track shipments and schedules', 'Liaise with vendors and teams', 'Ensure timely delivery']
  },
  {
    id: 'JR-080034',
    title: 'Facilities Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-07-28',
    description: 'Manage physical infrastructure, safety, and vendor contracts.',
    skills: ['Facility Management', 'Maintenance Planning', 'Vendor Coordination', 'Budgeting'],
    responsibilities: ['Maintain facility standards', 'Coordinate repairs and upgrades', 'Manage service providers']
  },
  {
    id: 'JR-080035',
    title: 'Training Coordinator',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-07-28',
    description: 'Organize employee training programs and track learning metrics.',
    skills: ['Learning Management Systems', 'Scheduling', 'MS Office', 'Communication'],
    responsibilities: ['Plan training sessions', 'Maintain attendance and feedback', 'Assist trainers and staff']
  },
  {
    id: 'JR-080036',
    title: 'Event Planner',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Plan and manage corporate events and engagement activities.',
    skills: ['Event Planning', 'Vendor Management', 'Budgeting', 'Creativity'],
    responsibilities: ['Plan event logistics', 'Coordinate with vendors and venues', 'Ensure smooth execution']
  },
  {
    id: 'JR-080037',
    title: 'Legal Assistant',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Support the legal team with documentation and compliance tracking.',
    skills: ['Legal Documentation', 'Compliance', 'Contracts', 'Research'],
    responsibilities: ['Prepare legal drafts', 'Maintain records', 'Assist in legal proceedings']
  },
  {
    id: 'JR-080038',
    title: 'Receptionist',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-07-28',
    description: 'Greet visitors and manage front-desk operations.',
    skills: ['Customer Service', 'Phone Etiquette', 'Communication', 'Multitasking'],
    responsibilities: ['Answer calls and emails', 'Greet clients', 'Manage appointments and logs']
  },
  {
    id: 'JR-080039',
    title: 'Public Relations Executive',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-07-28',
    description: 'Manage media relations, press releases, and brand presence.',
    skills: ['Media Relations', 'Content Writing', 'Social Media', 'Brand Management'],
    responsibilities: ['Draft press content', 'Liaise with media houses', 'Promote corporate image']
  },
  {
    id: 'JR-080040',
    title: 'Health & Safety Officer',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-07-28',
    description: 'Ensure workplace safety compliance and training.',
    skills: ['Risk Assessment', 'Safety Audits', 'Emergency Planning', 'Regulatory Compliance'],
    responsibilities: ['Conduct safety checks', 'Implement protocols', 'Report incidents and train employees']
  },
  {
  id: 'JR-080041',
  title: 'Inventory Control Specialist',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '1-3 years',
  postedDate: '2025-07-29',
  description: 'Responsible for inventory control specialist operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080042',
  title: 'Technical Writer',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '2-4 years',
  postedDate: '2025-07-30',
  description: 'Responsible for technical writer operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080043',
  title: 'Business Analyst - Non-IT',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '3-5 years',
  postedDate: '2025-07-31',
  description: 'Responsible for business analyst - non-it operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080044',
  title: 'Finance Executive',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '1-3 years',
  postedDate: '2025-08-01',
  description: 'Responsible for finance executive operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080045',
  title: 'Marketing Coordinator',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '2-4 years',
  postedDate: '2025-08-02',
  description: 'Responsible for marketing coordinator operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080046',
  title: 'Sales Coordinator',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '3-5 years',
  postedDate: '2025-08-03',
  description: 'Responsible for sales coordinator operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080047',
  title: 'Customer Relationship Manager',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '1-3 years',
  postedDate: '2025-08-04',
  description: 'Responsible for customer relationship manager operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080048',
  title: 'Payroll Executive',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '2-4 years',
  postedDate: '2025-08-05',
  description: 'Responsible for payroll executive operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080049',
  title: 'Quality Assurance Officer',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '3-5 years',
  postedDate: '2025-08-06',
  description: 'Responsible for quality assurance officer operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
{
  id: 'JR-080050',
  title: 'Operations Analyst',
  designation: 'Executive',
  department: 'Non-IT',
  locations: Locations,
  experience: '1-3 years',
  postedDate: '2025-08-07',
  description: 'Responsible for operations analyst operations and execution.',
  skills: ['Communication', 'Teamwork', 'MS Office', 'Process Coordination'],
  responsibilities: ['Coordinate department tasks', 'Support administrative functions']
},
  {
    id: 'JR-080051',
    title: 'Java Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-5 years',
    postedDate: '2025-08-06',
    description: 'Develop scalable applications using Java and Spring.',
    skills: ['Java', 'Spring Boot', 'JPA', 'Hibernate', 'REST APIs', 'Maven', 'MySQL'],
    responsibilities: ['Develop backend services', 'Integrate APIs', 'Write clean and scalable code']
  },
  {
    id: 'JR-080052',
    title: 'Python Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-07',
    description: 'Develop applications and APIs using Python frameworks.',
    skills: ['Python', 'Flask', 'Django', 'FastAPI', 'PostgreSQL', 'APIs'],
    responsibilities: ['Build REST APIs', 'Work on automation scripts', 'Database integration']
  },
  {
    id: 'JR-080053',
    title: 'SAP HR Consultant',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-6 years',
    postedDate: '2025-08-08',
    description: 'Support SAP HR modules and configurations.',
    skills: ['SAP HR', 'Payroll', 'Time Management', 'PA/OM Modules', 'ABAP basics'],
    responsibilities: ['Configure HR modules', 'Support payroll process', 'Work with functional teams']
  },
  {
    id: 'JR-080054',
    title: 'Oracle DBA',
    designation: 'Database Administrator',
    department: 'IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-09',
    description: 'Administer Oracle databases and ensure performance.',
    skills: ['Oracle DB', 'PL/SQL', 'Performance Tuning', 'Backup & Recovery'],
    responsibilities: ['Manage Oracle databases', 'Ensure uptime', 'Tune queries']
  },
  {
    id: 'JR-080055',
    title: 'IT Support Engineer',
    designation: 'Support Engineer',
    department: 'IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-10',
    description: 'Provide L1/L2 technical support for systems and software.',
    skills: ['Troubleshooting', 'Networking', 'Windows/Linux', 'Helpdesk tools'],
    responsibilities: ['Resolve tickets', 'Support end-users', 'Monitor systems']
  },
  {
    id: 'JR-080056',
    title: 'Network Engineer',
    designation: 'Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-11',
    description: 'Manage and configure network infrastructure.',
    skills: ['Cisco', 'Routing', 'Switching', 'Firewalls', 'VPN'],
    responsibilities: ['Configure routers/switches', 'Monitor network traffic', 'Maintain security']
  },
  {
    id: 'JR-080057',
    title: 'ERP Functional Consultant',
    designation: 'Consultant',
    department: 'IT',
    locations: Locations,
    experience: '3-6 years',
    postedDate: '2025-08-12',
    description: 'Implement and support ERP modules across functions.',
    skills: ['ERP', 'SAP', 'Oracle ERP', 'Functional Knowledge'],
    responsibilities: ['Support ERP rollouts', 'Configure modules', 'Liaise with business users']
  },
{
    id: 'JR-080058',
    title: 'HR Executive',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-13',
    description: 'Handle recruitment, onboarding, and HR operations.',
    skills: ['Recruitment', 'Payroll', 'HRMS', 'Onboarding'],
    responsibilities: ['Hire and onboard employees', 'Maintain HR records', 'Payroll support']
  },
  {
    id: 'JR-080059',
    title: 'HR Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '5-7 years',
    postedDate: '2025-08-14',
    description: 'Lead HR policies, employee engagement, and compliance.',
    skills: ['Employee Relations', 'HR Policies', 'Talent Management'],
    responsibilities: ['Design HR policies', 'Oversee employee engagement', 'Ensure compliance']
  },
  {
    id: 'JR-080060',
    title: 'Customer Support Executive',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-2 years',
    postedDate: '2025-08-15',
    description: 'Assist customers with queries and issues.',
    skills: ['Customer Handling', 'CRM tools', 'Communication'],
    responsibilities: ['Answer queries via calls/emails', 'Resolve customer complaints', 'Maintain records']
  },
  {
    id: 'JR-080061',
    title: 'Finance Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '5-8 years',
    postedDate: '2025-08-16',
    description: 'Oversee financial operations and compliance.',
    skills: ['Budgeting', 'Forecasting', 'Accounting Standards'],
    responsibilities: ['Prepare budgets', 'Oversee audits', 'Manage cash flow']
  },
  {
    id: 'JR-080062',
    title: 'Accounts Executive',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-17',
    description: 'Manage accounts payable, receivable, and bookkeeping.',
    skills: ['Tally', 'Excel', 'GST Filing', 'Bookkeeping'],
    responsibilities: ['Maintain accounts', 'Support tax filing', 'Prepare invoices']
  },
  {
    id: 'JR-080063',
    title: 'Marketing Executive',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-18',
    description: 'Plan and execute marketing campaigns.',
    skills: ['Digital Marketing', 'SEO', 'Content Writing', 'Google Ads'],
    responsibilities: ['Run campaigns', 'Analyze performance', 'Coordinate with sales']
  },
  {
    id: 'JR-080064',
    title: 'Sales Executive',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-19',
    description: 'Drive sales and meet revenue targets.',
    skills: ['Sales', 'CRM', 'Negotiation', 'Lead Generation'],
    responsibilities: ['Meet clients', 'Generate leads', 'Close sales']
  },
  {
    id: 'JR-080065',
    title: 'Admin Executive',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-3 years',
    postedDate: '2025-08-20',
    description: 'Manage administrative activities and office coordination.',
    skills: ['Administration', 'Coordination', 'Vendor Management'],
    responsibilities: ['Maintain admin records', 'Coordinate office activities', 'Support employees']
  },
  {
    id: 'JR-080066',
    title: 'Operations Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-21',
    description: 'Oversee daily business operations for efficiency.',
    skills: ['Operations', 'Process Improvement', 'Team Management'],
    responsibilities: ['Monitor processes', 'Improve workflows', 'Ensure delivery standards']
  },
  {
    id: 'JR-080067',
    title: 'Full Stack Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-22',
    description: 'Develop and maintain full stack web applications.',
    skills: ['JavaScript', 'React', 'Node.js', 'Express', 'MongoDB', 'SQL', 'REST APIs'],
    responsibilities: ['Develop frontend and backend', 'Integrate APIs', 'Maintain databases']
  },
  {
    id: 'JR-080068',
    title: 'UI/UX Designer',
    designation: 'Designer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Design user interfaces and user experiences for web and mobile apps.',
    skills: ['Figma', 'Sketch', 'Adobe XD', 'User Research', 'Prototyping', 'Wireframing'],
    responsibilities: ['Create UI designs', 'Conduct user research', 'Develop prototypes']
  },
  {
    id: 'JR-080069',
    title: 'Product Manager',
    designation: 'Manager',
    department: 'IT',
    locations: Locations,
    experience: '4-7 years',
    postedDate: '2025-08-22',
    description: 'Lead product development and strategy.',
    skills: ['Product Lifecycle', 'Agile', 'Scrum', 'Roadmapping', 'Stakeholder Management'],
    responsibilities: ['Define product vision', 'Coordinate teams', 'Manage releases']
  },
  {
    id: 'JR-080070',
    title: 'Technical Support Specialist',
    designation: 'Support Engineer',
    department: 'IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-22',
    description: 'Provide technical support and troubleshooting for software products.',
    skills: ['Troubleshooting', 'Customer Service', 'Ticketing Systems', 'Remote Support'],
    responsibilities: ['Resolve technical issues', 'Assist customers', 'Document solutions']
  },
  {
    id: 'JR-080071',
    title: 'Database Administrator',
    designation: 'Database Administrator',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-22',
    description: 'Manage and maintain database systems.',
    skills: ['SQL', 'Oracle', 'MySQL', 'PostgreSQL', 'Backup and Recovery', 'Performance Tuning'],
    responsibilities: ['Ensure database availability', 'Optimize queries', 'Manage backups']
  },
  {
    id: 'JR-080072',
    title: 'Cloud Solutions Architect',
    designation: 'Architect',
    department: 'IT',
    locations: Locations,
    experience: '5-8 years',
    postedDate: '2025-08-22',
    description: 'Design cloud infrastructure and solutions.',
    skills: ['AWS', 'Azure', 'GCP', 'Cloud Security', 'Infrastructure as Code'],
    responsibilities: ['Design cloud architecture', 'Ensure security and scalability', 'Guide implementation']
  },
  {
    id: 'JR-080073',
    title: 'Cybersecurity Specialist',
    designation: 'Security Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-6 years',
    postedDate: '2025-08-22',
    description: 'Protect systems and networks from cyber threats.',
    skills: ['Firewalls', 'SIEM', 'Penetration Testing', 'Incident Response', 'Encryption'],
    responsibilities: ['Monitor security', 'Conduct audits', 'Respond to incidents']
  },
  {
    id: 'JR-080074',
    title: 'Mobile Developer - Flutter',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Develop cross-platform mobile apps using Flutter.',
    skills: ['Dart', 'Flutter', 'Firebase', 'REST APIs', 'UI Design'],
    responsibilities: ['Build mobile apps', 'Integrate APIs', 'Optimize performance']
  },
  {
    id: 'JR-080075',
    title: 'Data Analyst',
    designation: 'Analyst',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Analyze data to provide business insights.',
    skills: ['SQL', 'Excel', 'Tableau', 'Power BI', 'Data Visualization'],
    responsibilities: ['Collect and analyze data', 'Create reports', 'Support decision making']
  },
  {
    id: 'JR-080076',
    title: 'Machine Learning Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-22',
    description: 'Develop and deploy machine learning models.',
    skills: ['Python', 'TensorFlow', 'PyTorch', 'Scikit-learn', 'Data Preprocessing'],
    responsibilities: ['Build ML models', 'Optimize algorithms', 'Deploy models']
  },
  {
    id: 'JR-080077',
    title: 'IT Project Manager',
    designation: 'Manager',
    department: 'IT',
    locations: Locations,
    experience: '5-7 years',
    postedDate: '2025-08-22',
    description: 'Manage IT projects from initiation to closure.',
    skills: ['Project Management', 'Agile', 'Scrum', 'Risk Management', 'Stakeholder Communication'],
    responsibilities: ['Plan projects', 'Manage teams', 'Ensure delivery']
  },
  {
    id: 'JR-080078',
    title: 'Network Administrator',
    designation: 'Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Maintain and troubleshoot network infrastructure.',
    skills: ['Cisco', 'Routing', 'Switching', 'Firewalls', 'VPN'],
    responsibilities: ['Monitor network', 'Configure devices', 'Resolve issues']
  },
  {
    id: 'JR-080079',
    title: 'Business Intelligence Developer',
    designation: 'Developer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-22',
    description: 'Develop BI solutions and dashboards.',
    skills: ['SQL', 'Power BI', 'Tableau', 'Data Warehousing', 'ETL'],
    responsibilities: ['Create BI reports', 'Develop ETL processes', 'Support analytics']
  },
  {
    id: 'JR-080080',
    title: 'Technical Writer',
    designation: 'Writer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Create technical documentation and manuals.',
    skills: ['Writing', 'Documentation Tools', 'API Documentation', 'Editing'],
    responsibilities: ['Write manuals', 'Update docs', 'Collaborate with teams']
  },
  {
    id: 'JR-080081',
    title: 'Scrum Master',
    designation: 'Manager',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-22',
    description: 'Facilitate Agile Scrum processes and team collaboration.',
    skills: ['Scrum', 'Agile', 'Facilitation', 'Conflict Resolution', 'Coaching'],
    responsibilities: ['Run Scrum ceremonies', 'Remove impediments', 'Coach teams']
  },
  {
    id: 'JR-080082',
    title: 'QA Engineer',
    designation: 'Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Test software products to ensure quality.',
    skills: ['Manual Testing', 'Automation Testing', 'Selenium', 'JIRA', 'Test Cases'],
    responsibilities: ['Write test cases', 'Execute tests', 'Report bugs']
  },
  {
    id: 'JR-080083',
    title: 'DevOps Engineer',
    designation: 'Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-22',
    description: 'Implement CI/CD pipelines and infrastructure automation.',
    skills: ['Docker', 'Kubernetes', 'Jenkins', 'Terraform', 'AWS', 'Azure'],
    responsibilities: ['Automate deployments', 'Manage infrastructure', 'Monitor systems']
  },
  {
    id: 'JR-080084',
    title: 'Software Tester',
    designation: 'Tester',
    department: 'IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-22',
    description: 'Perform software testing and report defects.',
    skills: ['Testing', 'Bug Tracking', 'Test Plans', 'Regression Testing'],
    responsibilities: ['Test software', 'Log defects', 'Verify fixes']
  },
  {
    id: 'JR-080085',
    title: 'Technical Recruiter',
    designation: 'Recruiter',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Recruit technical talent for IT roles.',
    skills: ['Recruitment', 'Interviewing', 'ATS', 'Networking'],
    responsibilities: ['Source candidates', 'Conduct interviews', 'Coordinate hiring']
  },
  {
    id: 'JR-080086',
    title: 'IT Consultant',
    designation: 'Consultant',
    department: 'IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-22',
    description: 'Advise clients on IT strategy and solutions.',
    skills: ['IT Strategy', 'Consulting', 'Project Management', 'Cloud Computing'],
    responsibilities: ['Assess client needs', 'Recommend solutions', 'Support implementation']
  },
  {
    id: 'JR-080087',
    title: 'Accountant',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Manage financial records and transactions.',
    skills: ['Accounting', 'Tally', 'GST', 'Excel', 'Bookkeeping'],
    responsibilities: ['Maintain accounts', 'Prepare financial reports', 'Ensure compliance']
  },
  {
    id: 'JR-080088',
    title: 'Auditor',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-22',
    description: 'Conduct financial and compliance audits.',
    skills: ['Auditing', 'Risk Assessment', 'Compliance', 'Reporting'],
    responsibilities: ['Perform audits', 'Identify risks', 'Report findings']
  },
  {
    id: 'JR-080089',
    title: 'Compliance Officer',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-22',
    description: 'Ensure organizational compliance with laws and regulations.',
    skills: ['Regulatory Compliance', 'Policy Development', 'Risk Management'],
    responsibilities: ['Develop policies', 'Monitor compliance', 'Conduct training']
  },
  {
    id: 'JR-080090',
    title: 'HR Coordinator',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Support HR operations and employee relations.',
    skills: ['Recruitment', 'Payroll', 'Employee Relations', 'HRMS'],
    responsibilities: ['Assist recruitment', 'Maintain records', 'Support payroll']
  },
  {
    id: 'JR-080091',
    title: 'Office Assistant',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-22',
    description: 'Provide administrative support to office staff.',
    skills: ['Administration', 'Communication', 'Scheduling'],
    responsibilities: ['Manage schedules', 'Handle correspondence', 'Support staff']
  },
  {
    id: 'JR-080092',
    title: 'Receptionist',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-22',
    description: 'Manage front desk and greet visitors.',
    skills: ['Customer Service', 'Communication', 'Multitasking'],
    responsibilities: ['Answer calls', 'Greet visitors', 'Manage appointments']
  },
  {
    id: 'JR-080093',
    title: 'Marketing Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '5-7 years',
    postedDate: '2025-08-22',
    description: 'Lead marketing strategies and campaigns.',
    skills: ['Marketing', 'SEO', 'Content Creation', 'Team Leadership'],
    responsibilities: ['Develop marketing plans', 'Manage campaigns', 'Lead team']
  },
  {
    id: 'JR-080094',
    title: 'Sales Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '5-7 years',
    postedDate: '2025-08-22',
    description: 'Drive sales strategies and manage sales teams.',
    skills: ['Sales', 'CRM', 'Negotiation', 'Leadership'],
    responsibilities: ['Set sales targets', 'Manage sales team', 'Develop client relationships']
  },
  {
    id: 'JR-080095',
    title: 'Customer Service Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-22',
    description: 'Oversee customer service operations and quality.',
    skills: ['Customer Service', 'Team Management', 'Problem Solving'],
    responsibilities: ['Manage service team', 'Handle escalations', 'Improve service quality']
  },
  {
    id: 'JR-080096',
    title: 'Logistics Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-22',
    description: 'Manage logistics and supply chain operations.',
    skills: ['Logistics', 'Supply Chain', 'Vendor Management', 'Planning'],
    responsibilities: ['Coordinate shipments', 'Manage vendors', 'Optimize logistics']
  },
  {
    id: 'JR-080097',
    title: 'Training Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-22',
    description: 'Plan and oversee employee training programs.',
    skills: ['Training', 'LMS', 'Scheduling', 'Communication'],
    responsibilities: ['Develop training plans', 'Coordinate sessions', 'Evaluate effectiveness']
  },
  {
    id: 'JR-080098',
    title: 'Event Coordinator',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-22',
    description: 'Organize corporate events and activities.',
    skills: ['Event Planning', 'Vendor Coordination', 'Budgeting'],
    responsibilities: ['Plan events', 'Manage vendors', 'Ensure smooth execution']
  },
  {
    id: 'JR-080099',
    title: 'Legal Counsel',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '5-7 years',
    postedDate: '2025-08-22',
    description: 'Provide legal advice and support to the organization.',
    skills: ['Legal Research', 'Contract Law', 'Compliance', 'Negotiation'],
    responsibilities: ['Advise on legal matters', 'Draft contracts', 'Manage legal risks']
  },
  {
    id: 'JR-080100',
    title: 'Health & Safety Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-22',
    description: 'Ensure workplace health and safety compliance.',
    skills: ['Safety Audits', 'Risk Assessment', 'Training', 'Regulatory Compliance'],
    responsibilities: ['Conduct safety inspections', 'Implement protocols', 'Train employees']
  },
  {
    id: 'JR-080107',
    title: 'AI Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Develop AI models and systems using latest technologies.',
    skills: ['Python', 'TensorFlow', 'PyTorch', 'Keras', 'Deep Learning', 'NLP'],
    responsibilities: ['Build AI models', 'Optimize algorithms', 'Deploy AI solutions']
  },
  {
    id: 'JR-080108',
    title: 'ML Ops Engineer',
    designation: 'Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Manage ML pipelines and operations.',
    skills: ['MLflow', 'Kubeflow', 'Docker', 'Kubernetes', 'CI/CD', 'Monitoring'],
    responsibilities: ['Automate ML workflows', 'Monitor model performance', 'Ensure scalability']
  },
  {
    id: 'JR-080109',
    title: 'Blockchain Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Develop blockchain-based applications and smart contracts.',
    skills: ['Solidity', 'Ethereum', 'Hyperledger', 'Cryptography', 'Smart Contracts'],
    responsibilities: ['Write smart contracts', 'Develop DApps', 'Ensure security']
  },
  {
    id: 'JR-080110',
    title: 'IoT Specialist',
    designation: 'Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Design and implement IoT solutions.',
    skills: ['Embedded Systems', 'Sensors', 'MQTT', 'Edge Computing', 'Cloud IoT'],
    responsibilities: ['Integrate IoT devices', 'Develop firmware', 'Monitor IoT networks']
  },
  {
    id: 'JR-080111',
    title: 'Cloud Security Engineer',
    designation: 'Security Engineer',
    department: 'IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Secure cloud infrastructures and data.',
    skills: ['AWS Security', 'Azure Security', 'IAM', 'Encryption', 'Compliance'],
    responsibilities: ['Implement security measures', 'Conduct audits', 'Respond to threats']
  },
  {
    id: 'JR-080112',
    title: 'DevSecOps Specialist',
    designation: 'Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Integrate security into DevOps processes.',
    skills: ['DevOps', 'Security Tools', 'Automation', 'Vulnerability Scanning', 'Compliance'],
    responsibilities: ['Secure CI/CD pipelines', 'Automate security checks', 'Train teams']
  },
  {
    id: 'JR-080113',
    title: 'Quantum Computing Researcher',
    designation: 'Researcher',
    department: 'IT',
    locations: Locations,
    experience: '5-8 years',
    postedDate: '2025-08-23',
    description: 'Research and develop quantum computing applications.',
    skills: ['Quantum Mechanics', 'Qisk', 'Python', 'Algorithms', 'Simulation'],
    responsibilities: ['Develop quantum algorithms', 'Simulate quantum systems', 'Collaborate on research']
  },
  {
    id: 'JR-080114',
    title: 'AR/VR Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Create immersive AR/VR experiences.',
    skills: ['Unity', 'Unreal Engine', 'C#', '3D Modeling', 'VR Headsets'],
    responsibilities: ['Develop AR/VR apps', 'Optimize performance', 'Integrate sensors']
  },
  {
    id: 'JR-080115',
    title: 'Robotics Software Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Develop software for robotic systems.',
    skills: ['ROS', 'Python', 'C++', 'Computer Vision', 'Control Systems'],
    responsibilities: ['Program robots', 'Integrate sensors', 'Test automation']
  },
  {
    id: 'JR-080116',
    title: 'Big Data Architect',
    designation: 'Architect',
    department: 'IT',
    locations: Locations,
    experience: '5-7 years',
    postedDate: '2025-08-23',
    description: 'Design big data solutions and architectures.',
    skills: ['Hadoop', 'Spark', 'Kafka', 'Data Warehousing', 'Cloud Storage'],
    responsibilities: ['Design data pipelines', 'Optimize storage', 'Ensure scalability']
  },
  {
    id: 'JR-080117',
    title: 'Data Science Consultant',
    designation: 'Consultant',
    department: 'IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Provide data-driven insights and strategies.',
    skills: ['Python', 'R', 'Statistics', 'Visualization', 'Business Intelligence'],
    responsibilities: ['Analyze data', 'Build models', 'Advise on strategies']
  },
  {
    id: 'JR-080118',
    title: 'NLP Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Develop natural language processing applications.',
    skills: ['Python', 'NLTK', 'SpaCy', 'Transformers', 'BERT', 'Text Mining'],
    responsibilities: ['Build NLP models', 'Process text data', 'Integrate chatbots']
  },
  {
    id: 'JR-080119',
    title: 'Computer Vision Engineer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Develop computer vision systems and applications.',
    skills: ['OpenCV', 'TensorFlow', 'PyTorch', 'Image Processing', 'Deep Learning'],
    responsibilities: ['Build vision models', 'Analyze images/videos', 'Optimize algorithms']
  },
  {
    id: 'JR-080120',
    title: 'Edge Computing Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Develop applications for edge computing environments.',
    skills: ['IoT', 'Edge Devices', 'Kubernetes', 'MQTT', 'Real-time Processing'],
    responsibilities: ['Deploy edge apps', 'Optimize latency', 'Integrate with cloud']
  },
  {
    id: 'JR-080121',
    title: '5G Network Engineer',
    designation: 'Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Design and manage 5G network infrastructures.',
    skills: ['5G Standards', 'Network Design', 'RF Engineering', 'SDN', 'NFV'],
    responsibilities: ['Configure 5G networks', 'Optimize performance', 'Troubleshoot issues']
  },
  {
    id: 'JR-080122',
    title: 'Cybersecurity Analyst (Advanced)',
    designation: 'Security Engineer',
    department: 'IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Advanced threat detection and response.',
    skills: ['SIEM', 'Threat Hunting', 'Forensics', 'Incident Response', 'AI Security'],
    responsibilities: ['Monitor threats', 'Conduct investigations', 'Implement defenses']
  },
  {
    id: 'JR-080123',
    title: 'Ethical Hacker',
    designation: 'Security Engineer',
    department: 'IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Perform ethical hacking and vulnerability assessments.',
    skills: ['Penetration Testing', 'Kali Linux', 'Metasploit', 'Vulnerability Scanning', 'Reporting'],
    responsibilities: ['Identify vulnerabilities', 'Simulate attacks', 'Provide recommendations']
  },
  {
    id: 'JR-080124',
    title: 'Digital Forensics Expert',
    designation: 'Security Engineer',
    department: 'IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Investigate digital crimes and data breaches.',
    skills: ['Forensics Tools', 'Data Recovery', 'Chain of Custody', 'Legal Knowledge'],
    responsibilities: ['Analyze digital evidence', 'Preserve data', 'Report findings']
  },
  {
    id: 'JR-080125',
    title: 'AI Product Manager',
    designation: 'Manager',
    department: 'IT',
    locations: Locations,
    experience: '5-7 years',
    postedDate: '2025-08-23',
    description: 'Manage AI product development and strategy.',
    skills: ['Product Management', 'AI/ML', 'Agile', 'Stakeholder Management', 'Data Analysis'],
    responsibilities: ['Define AI products', 'Coordinate teams', 'Measure success']
  },
  {
    id: 'JR-080126',
    title: 'Metaverse Developer',
    designation: 'Software Engineer',
    department: 'IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Build virtual worlds and metaverse experiences.',
    skills: ['Unity', 'Unreal Engine', 'Blockchain', 'VR/AR', '3D Design'],
    responsibilities: ['Develop metaverse apps', 'Integrate NFTs', 'Ensure user engagement']
  },
  {
    id: 'JR-080127',
    title: 'Digital Marketing Specialist',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Plan and execute digital marketing campaigns.',
    skills: ['SEO', 'SEM', 'Social Media', 'Google Analytics', 'Content Marketing'],
    responsibilities: ['Run campaigns', 'Analyze performance', 'Optimize strategies']
  },
  {
    id: 'JR-080128',
    title: 'Social Media Manager',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Manage social media presence and engagement.',
    skills: ['Social Platforms', 'Content Creation', 'Analytics', 'Community Management'],
    responsibilities: ['Create content', 'Engage audience', 'Grow followers']
  },
  {
    id: 'JR-080129',
    title: 'E-commerce Manager',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Oversee e-commerce operations and growth.',
    skills: ['E-commerce Platforms', 'Analytics', 'Customer Insights', 'Marketing'],
    responsibilities: ['Manage online sales', 'Optimize conversions', 'Analyze trends']
  },
  {
    id: 'JR-080130',
    title: 'Content Creator',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-23',
    description: 'Create engaging content for digital platforms.',
    skills: ['Writing', 'Graphic Design', 'Video Editing', 'SEO', 'Social Media'],
    responsibilities: ['Produce content', 'Edit media', 'Publish across channels']
  },
  {
    id: 'JR-080131',
    title: 'SEO Specialist',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Optimize websites for search engines.',
    skills: ['SEO Tools', 'Keyword Research', 'On-page SEO', 'Analytics', 'Link Building'],
    responsibilities: ['Improve rankings', 'Conduct audits', 'Monitor performance']
  },
  {
    id: 'JR-080132',
    title: 'PPC Manager',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Manage pay-per-click advertising campaigns.',
    skills: ['Google Ads', 'Bing Ads', 'Analytics', 'A/B Testing', 'Budget Management'],
    responsibilities: ['Create campaigns', 'Optimize bids', 'Report ROI']
  },
  {
    id: 'JR-080133',
    title: 'Influencer Marketing Coordinator',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Coordinate influencer partnerships and campaigns.',
    skills: ['Influencer Outreach', 'Social Media', 'Negotiation', 'Campaign Tracking'],
    responsibilities: ['Identify influencers', 'Manage partnerships', 'Measure impact']
  },
  {
    id: 'JR-080134',
    title: 'Data Privacy Officer',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Ensure data privacy and compliance.',
    skills: ['GDPR', 'CCPA', 'Data Protection', 'Risk Assessment', 'Auditing'],
    responsibilities: ['Develop policies', 'Conduct audits', 'Train staff']
  },
  {
    id: 'JR-080135',
    title: 'Sustainability Coordinator',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Promote sustainability initiatives.',
    skills: ['Environmental Science', 'Sustainability Reporting', 'Project Management', 'Communication'],
    responsibilities: ['Implement green practices', 'Track metrics', 'Educate employees']
  },
  {
    id: 'JR-080136',
    title: 'Remote Work Coordinator',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Support remote work policies and tools.',
    skills: ['Remote Tools', 'Communication', 'Policy Development', 'Training'],
    responsibilities: ['Set up remote infrastructure', 'Provide support', 'Monitor productivity']
  },
  {
    id: 'JR-080137',
    title: 'Diversity and Inclusion Officer',
    designation: 'Manager',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Promote diversity and inclusion in the workplace.',
    skills: ['D&I Strategies', 'Training', 'Policy Development', 'Stakeholder Engagement'],
    responsibilities: ['Develop programs', 'Conduct training', 'Measure progress']
  },
  {
    id: 'JR-080138',
    title: 'Corporate Trainer (Digital)',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Deliver digital training programs.',
    skills: ['E-learning', 'LMS', 'Content Development', 'Facilitation', 'Assessment'],
    responsibilities: ['Design courses', 'Deliver training', 'Evaluate effectiveness']
  },
  {
    id: 'JR-080139',
    title: 'Virtual Event Planner',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Plan and execute virtual events.',
    skills: ['Event Platforms', 'Video Conferencing', 'Content Creation', 'Engagement'],
    responsibilities: ['Organize events', 'Coordinate speakers', 'Manage logistics']
  },
  {
    id: 'JR-080140',
    title: 'Telecommuting Support Specialist',
    designation: 'Executive',
    department: 'Non-IT',
    locations: Locations,
    experience: '1-3 years',
    postedDate: '2025-08-23',
    description: 'Support telecommuting employees.',
    skills: ['IT Support', 'Communication', 'Troubleshooting', 'Remote Tools'],
    responsibilities: ['Assist remote workers', 'Resolve issues', 'Provide training']
  },
  {
    id: 'JR-080141',
    title: 'Green Energy Consultant',
    designation: 'Consultant',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Advise on green energy solutions.',
    skills: ['Renewable Energy', 'Sustainability', 'Policy', 'Project Management'],
    responsibilities: ['Assess needs', 'Recommend solutions', 'Implement projects']
  },
  {
    id: 'JR-080142',
    title: 'ESG Analyst',
    designation: 'Analyst',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Analyze environmental, social, and governance factors.',
    skills: ['ESG Frameworks', 'Data Analysis', 'Reporting', 'Sustainability'],
    responsibilities: ['Conduct ESG assessments', 'Prepare reports', 'Advise on improvements']
  },
  {
    id: 'JR-080143',
    title: 'Supply Chain Analyst',
    designation: 'Analyst',
    department: 'Non-IT',
    locations: Locations,
    experience: '2-4 years',
    postedDate: '2025-08-23',
    description: 'Analyze supply chain operations.',
    skills: ['Supply Chain Management', 'Data Analysis', 'Forecasting', 'ERP'],
    responsibilities: ['Monitor performance', 'Identify inefficiencies', 'Recommend optimizations']
  },
  {
    id: 'JR-080144',
    title: 'Logistics Technology Specialist',
    designation: 'Specialist',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Implement technology in logistics.',
    skills: ['Logistics Software', 'IoT', 'Automation', 'Data Analytics'],
    responsibilities: ['Integrate tech solutions', 'Train staff', 'Monitor systems']
  },
  {
    id: 'JR-080145',
    title: 'Customer Experience Designer',
    designation: 'Designer',
    department: 'Non-IT',
    locations: Locations,
    experience: '3-5 years',
    postedDate: '2025-08-23',
    description: 'Design customer experience strategies.',
    skills: ['UX Design', 'Customer Journey Mapping', 'Research', 'Prototyping'],
    responsibilities: ['Map experiences', 'Design solutions', 'Test improvements']
  },
  {
    id: 'JR-080146',
    title: 'Brand Strategist',
    designation: 'Strategist',
    department: 'Non-IT',
    locations: Locations,
    experience: '4-6 years',
    postedDate: '2025-08-23',
    description: 'Develop brand strategies and positioning.',
    skills: ['Brand Management', 'Market Research', 'Creative Strategy', 'Marketing'],
    responsibilities: ['Define brand identity', 'Develop campaigns', 'Measure brand equity']
  }
];

export default jobs;
